import { render, staticRenderFns } from "./CertificationOffNotice.vue?vue&type=template&id=73ff44a6&"
import script from "./CertificationOffNotice.vue?vue&type=script&lang=js&"
export * from "./CertificationOffNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports